import {Component, h} from "preact";


export class Loading extends Component
{
	/**
	 * @inheritDoc
	 */
	render ()
	{
		return (
			<p>Lädt...</p>
		);
	}
}
